import React from 'react'
import { Skeleton } from 'antd'

export const line = <Skeleton paragraph={{ rows: 0 }} size="small" active style={{ width: 200 }} />